import { t } from '@lingui/core/macro';
import { WheelPickupOutcome } from '@navio/nsdk';
import { CustomDateFormats, type CustomerTimelineWheelPickup, noddiFormatDate } from 'noddi-util';
import { getLongAddressName } from 'noddi-web';

export function getWheelPickupDescription(pickup: CustomerTimelineWheelPickup): string {
  const pickupLocation = getLongAddressName(pickup.address);
  switch (pickup.outcome) {
    case WheelPickupOutcome.COLLECTED:
      return t`We picked up your tires from ${pickupLocation}.`;
    case WheelPickupOutcome.PLANNED: {
      const plannedDate = noddiFormatDate(pickup.booking.deliveryWindowStartsAt, CustomDateFormats.FULL_DAY_MONTH);
      return t`We plan to pick up your tires from ${pickupLocation} on ${plannedDate}.`;
    }
  }
}
